import cs from 'classnames';
import { MouseEventHandler, ReactNode } from 'react';

import './FullscreenLayout.scss';

interface Props {
  id?: string;
  className?: string;
  /** 콘텐츠를 화면 중앙에 세로로 정렬 */
  center?: boolean;
  /** 상하 safe-area padding 없이 화면 끝까지 채움 (뷰어처럼 헤더/패널이 직접 safe-area를 처리하는 경우) */
  bleed?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  children?: ReactNode;
}

export default function FullscreenLayout({ id, className, center, bleed, onClick, children }: Props) {
  return (
    <div id={id} className={cs('FullscreenLayout', className, { center, bleed })} onClick={onClick}>
      {children}
    </div>
  );
}
